import * as React from 'react';
import { Route } from 'react-router';
import RootRoute from './root_route';

export default (routes) => ([
  <Route key="root" path="/" component={RootRoute}>{routes}</Route>,
  <Route key="region-root" path="/:region" component={RootRoute}>{routes}</Route>,
]);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/reverb-js-common/build_root_routes.jsx